<template>
  <div>
    <b-tabs class="pb-2">
      <b-tab title="Sản phẩm Đã sản Xuất">
        <div class="row">
          <div class="col-md-3">
            <div class="row-form mr-2">
              <label for="">Diễn giải</label>
              <base-select @change="reasonChange(reasonFilter)" v-model="reasonFilter" :ajaxData="getReason">
                <template v-slot:selected="{ item }">
                  <div>{{ item.key }} - {{ item.name }}</div>
                </template>
                <template v-slot:body="{ item }">
                  <div>
                    <strong>{{ item.key }}</strong> <br />
                    <span>{{ item.name }}</span>
                  </div>
                </template>
              </base-select>
            </div>
          </div>
          <div class="col-md-2">
            <div class="row-form mr-2">
              <label for="">Mã màu 1</label>
              <base-input v-model="colorCode1"></base-input>
              <!-- <color style="max-width:100%" v-model="colorCode1"></color> -->
            </div>
          </div>
          <div class="col-md-2">
            <div class="row-form mr-2">
              <label for="">Đơn vị</label>
              <base-select v-model="unit" :options="['M', 'Yard', 'Kg', 'Sợi']"></base-select>
            </div>
          </div>
          <div class="col-md-2">
            <div class="row-form mr-2">
              <label for="">Độ dài</label>
              <base-input v-model="length"></base-input>
            </div>
          </div>
          <div class="col-md-1">
            <button class="btn btn-primary btn-sm btn-block" @click="fetchData()">
              Tìm kiếm
            </button>
          </div>
        </div>
        <block :nobody="true" ref="buser" class="soft-control">
          <soft-table
            @rowSelected="tbSetRowSelected"
            @rowClicked="tbRowClicked"
            class="table align-items-center table-flush"
            tbody-classes="list"
            :pending="false"
            :dataTable="productInfos"
            :fields="fields"
            :minHeight="$hMainContent - 164"
            :showAll="true"
            :noDelete="true"
            @doEditRow="handleEdit"
            :contextMenus="[
              {
                key: 'convert',
                icon: 'fa-edit',
                label: 'Chuyển đổi đơn vị'
              },
              {
                key: 'history',
                icon: 'fa-history',
                label: 'Lịch sử tồn kho'
              },
              {
                key: 'out',
                icon: 'fa-shipping-fast',
                label: 'Xuất bỏ'
              }
            ]"
            @contextMenuItemClick="tbHandleContextMenuItemClick"
            ref="soft-table"
          >
            <template v-slot:cell(productSpecify)="{ value }">
              {{ value.id }} - <span class="badge badge-primary"> {{ value.name }} mm </span>
            </template>
            <template v-slot:cell(product_name)="">
              <span>{{ product.name }}</span>
            </template>
            <template v-slot:cell(product_code)="">
              <span>{{ product.code }} </span>
            </template>
            <template v-slot:cell(reason)="{ value }">
              <div v-if="value.id">{{ value.key }} - {{ value.name }}</div>
            </template>
            <template v-slot:cell(description)="{ value }">
              <div v-html="value"></div>
            </template>
            <template v-slot:cell(position)="{ value }">
              <div v-html="value"></div>
            </template>
            <template v-slot:cell(userVerify)="{ value }">
              <span v-if="value.id" class="badge badge-success">{{ value.username }}</span>
              <span v-else class="badge badge-danger">Chưa được duyệt</span>
            </template>
            <template v-slot:cell(userManage)="{ value }">
              <span v-if="value.id" class="badge badge-info">{{ value.username }}</span>
              <span v-else class="badge badge-danger">Chưa có người hỗ trợ</span>
            </template>
            <template v-slot:action="{ item }">
              <b-button @click="tbRowHandleFeatureInfo(item)" variant="primary px-1 py-0">
                <i class="fa fa-atom"></i> Thông số kỹ thuật</b-button
              >
            </template>
          </soft-table>
        </block>
      </b-tab>
      <!-- <b-tab title="Đang chế tạo"> </b-tab> -->
      <convertUnit @reloadProductInfo="$emit('reloadProductInfo')" ref="convertUnit"></convertUnit>
      <historyProductInfo ref="historyProductInfo"></historyProductInfo>
      <productInfoModal @reloadProductInfo="$emit('reloadProductInfo')" ref="productInfoModal"></productInfoModal>
    </b-tabs>
  </div>
</template>
<script>
import { productService } from '@/_services';
import convertUnit from './__ConvertUnit';
import historyProductInfo from './__HistoryProductInfo';
import productInfoModal from './__ProductInfoModal';
export default {
  props: {},
  components: { convertUnit, historyProductInfo, productInfoModal },
  data() {
    return {
      productInfos: [],
      fields: [
        {
          variant: 'primary',
          key: 'id',
          class: 'checkbox'
        },
        {
          key: 'product_name',
          tdClass: 'text-center',
          label: 'Tên sản phẩm'
        },
        {
          key: 'product_code',
          tdClass: 'text-center',
          label: 'Mã sản phẩm',
          class: 'text-center'
        },

        {
          key: 'colorText',
          tdClass: 'text-center',
          label: 'Màu sắc'
        },
        {
          key: 'colorCode1',
          tdClass: 'text-center',
          label: 'Mã màu 1'
        },
        {
          key: 'reason',
          tdClass: 'text-left',
          label: 'Diễn giải'
        },
        {
          key: 'productSpecify',
          tdClass: 'text-center',
          label: 'Quy cách'
        },

        {
          key: 'unit',
          tdClass: 'text-center',
          label: 'Đơn vị tính'
        },
        {
          key: 'length',
          tdClass: 'text-center',
          label: 'Độ dài'
        },
        {
          key: 'quantity',
          tdClass: 'text-center',
          label: 'Số lượng tồn'
        },
        {
          key: 'description',
          tdClass: 'text-center',
          label: 'Mô tả'
        },
        {
          key: 'position',
          tdClass: 'text-center',
          label: 'Vị trí lưu kho'
        }
      ],
      countChecked: 0,
      listQuery: {
        page: 1,
        limit: 30,
        total: 0
      },
      lastIndexCustomerSelected: 0,
      info: {},
      product: {},
      color: {},
      colorCode1: '',
      spec: {},
      length: '',
      reasonId: -1,
      reasonFilter: null,
      unit: '',
      isFilterAll: false
    };
  },
  mounted() {},
  methods: {
    fetchData() {
      productService
        .findListInfoOfProduct({
          productId: this.isFilterAll ? -1 : this.product.id,
          productSpecifyName: this.isFilterAll ? '' : this.spec.name,
          colorCode1: this.colorCode1,
          unit: this.unit,
          length: this.length,
          reasonId: this.reasonId,
          ...this.listQuery
        })
        .then(res => {
          this.productInfos = res.data.data;
          this.product.productInfos = res.data.data;
          this.listQuery.total = res.data.total;
        })
        .finally(() => {});
    },
    setData(product, spectProductUnit) {
      this.unit = spectProductUnit.unit;
      this.product = product;
      this.spec = spectProductUnit;
      this.color = spectProductUnit.color;
      if (this.product && this.product.id) {
        this.fetchData();
      } else {
        this.productInfos = [];
      }
    },
    pagChange(page) {
      this.listQuery.page = page;
      this.fetchData();
    },
    handleSearch(keyword) {
      if (keyword == '') {
        this.productSpecifys = this.product.productSpecifys;
      } else {
        this.productSpecifys = this.product.productSpecifys.filter(item => {
          //let keys = Object.keys(item)
          let keysCheck = ['name'];
          for (let i = 0; i < keysCheck.length; i++) {
            const key = keysCheck[i];
            let value = item[key];
            if (
              value &&
              value
                .toString()
                .toLowerCase()
                .includes(keyword.toLowerCase())
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    tbRowClicked(item, index) {
      this.info = item;
      this.lastIndexCustomerSelected = index;
    },
    tbRowHandleFeatureInfo(item) {
      this.$refs.specFeatureModal.visible = true;
      this.$refs.specFeatureModal.setData(this.product, item);
    },
    tbHandleContextMenuItemClick(a) {
      if (a.menu.key == 'spec_feature') {
        this.$refs.specFeatureModal.visible = true;
        this.$refs.specFeatureModal.setData(this.product, a.data);
      } else if (a.menu.key == 'copy') {
        let newItem = Object.assign({}, a.data);
        delete newItem.id;
        this.$refs.specModal.visible = true;
        this.$refs.specModal.setData(this.product, newItem);
      } else if (a.menu.key == 'edit') {
        this.$refs.specModal.visible = true;
        this.$refs.specModal.setData(this.product, a.data);
      } else if (a.menu.key == 'convert') {
        this.convertUnit(a.data);
      } else if (a.menu.key == 'history') {
        this.showHistory(a.data);
      } else if (a.menu.key == 'out') {
        this.$refs.productInfoModal.visible = true;
        this.$refs.productInfoModal.setDataFromProductInfo(this.product, a.data, 'OUT');
      }
    },
    convertUnit(productInfo) {
      productInfo.product = {
        id: this.product.id,
        code: this.product.code,
        name: this.product.name,
        type: this.product.type
      };
      this.$refs.convertUnit.visible = true;
      this.$refs.convertUnit.setData(productInfo);
    },
    showHistory(productInfo) {
      // productInfo.product = this.product;
      this.$refs.historyProductInfo.visible = true;
      this.$refs.historyProductInfo.setData(productInfo);
    },
    handleEdit() {
      this.$refs.specModal.visible = true;
      this.$refs.specModal.setData(this.product, this.info);
    },
    handleAddNew() {
      this.$refs.specModal.visible = true;
      this.$refs.specModal.setData(this.product, {});
    },
    handleCopy() {},
    handleHelp() {
      alert('help');
    },
    handleDeletes() {
      if (this.countChecked == 0) return;
    },
    tbSetRowSelected(items) {
      this.customerSelecteds = items;
      this.countChecked = items.length;
    },
    getReason(keyword, cb) {
      productService.findReason({ search: keyword }).then(res => {
        cb(res.data.data);
      });
    },
    reasonChange(row) {
      if (row) this.reasonId = row.id;
      else this.reasonId = -1;
      this.fetchData();
    }
  }
};
</script>
